import { App as AntdApp, ConfigProvider } from 'antd';
import enUS from 'antd/locale/en_US';
import type { ReactNode } from 'react';

import { adminTheme } from '@/config/theme';

export function AntdConfigProvider({ children }: { children: ReactNode }) {
  return (
    <ConfigProvider locale={enUS} theme={adminTheme}>
      <AntdApp>{children}</AntdApp>
    </ConfigProvider>
  );
}
